export default function ProblemStatement() {
  return (
    <section
      className="bg-slate-900 py-24 lg:py-32"
      data-testid="problem-statement-section"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
        <p
          className="text-sm uppercase tracking-[0.18em] text-sky-300/80 font-medium"
          data-testid="problem-statement-eyebrow"
        >
          The reality
        </p>
        <h2
          className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white leading-tight"
          data-testid="problem-statement-heading"
        >
          Work is changing faster than most of us can plan for.
        </h2>
        <p
          className="mt-8 text-lg sm:text-xl text-slate-300 leading-relaxed"
          data-testid="problem-statement-body"
        >
          {"Maybe you've already been laid off. Maybe your role has been quietly hollowed out by automation. Maybe you're just looking around and wondering how long until it's your turn. Whatever the case — the uncertainty is real, and you're not overreacting."}
        </p>
        <p className="mt-6 text-base text-slate-400 leading-relaxed">
          {"You don't need another think‑piece or a 30‑tab career checklist. You need a calm process, a clear set of steps, and someone in your corner."}
        </p>
      </div>
    </section>
  );
}
